import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ht from './locales/ht.json';
import es from './locales/es.json';
import fr from './locales/fr.json';

// Supported languages for the student-facing exam portal UI. This is scoped
// to the application's own chrome (buttons, labels, toasts, instructions) —
// exam/question content itself is data entered by institution admins and is
// never translated by this layer.
export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'ht', label: 'Kreyòl Ayisyen' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ht: { translation: ht },
      es: { translation: es },
      fr: { translation: fr },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'examPortalLanguage',
    },
  });

export default i18n;
